import axios from './axios'

export const getExpertPartnersList = () =>
	axios.get('/clients/partner-experts')

export const getPartnerExpertAccess = () =>
	axios.get('/partner_expert_access')

export const addClientAccessToExpertPartner = (data) =>
	axios.post('/jobs/assign-clients-to-service-provider', data)

export const removeClientAccessFromExpertPartner = (data) =>
	axios.post('/jobs/remove-clients-from-service-provider', data)

export const addExpertPartner = (data) =>
	axios.post('/clients/add-partner-expert', data)

export const updatePartnerExpertAccess = (data) =>
	axios.put('/partner_expert_access', data)

export const createPartnerExpert = (data) =>
	axios.post('/partner_expert_access/create', data)

export const softDeletePartnerExpert = (partnerExpertId) =>
	axios.post('/clients/soft-delete-user', { client_id: partnerExpertId })
